import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function getBoatType(boat) {
  if (!boat) return ''
  if (typeof boat.baadtype === 'string' && boat.baadtype.trim()) {
    return boat.baadtype
  }
  const term = boat.terms?.baadtype?.[0]
  if (term) {
    if (term === 'motorbaad') return 'Motorbåd'
    if (term === 'sejlbaad') return 'Sejlbåd'
    if (term === 'motorsejler') return 'Motorsejler'
    return term
  }
  return ''
}

export function getBoatStatus(boat) {
  if (!boat) return ''
  if (typeof boat.status === 'string' && boat.status.trim()) {
    return boat.status
  }
  const term = boat.terms?.status?.[0]
  if (term) {
    if (term === 'til-salg') return 'Til salg'
    if (term === 'nyhed') return 'Nyhed'
    if (term === 'nedsat') return 'Nedsat'
    if (term === 'solgt') return 'Solgt'
    return term
  }
  return ''
}

export function getBoatByggemateriale(boat) {
  if (!boat) return ''
  if (typeof boat.baddata_byggemateriale === 'string' && boat.baddata_byggemateriale.trim()) {
    return boat.baddata_byggemateriale
  }
  const term = boat.terms?.byggemateriale?.[0]
  if (term) {
    if (term === 'glasfiber') return 'Glasfiber'
    if (term === 'staal') return 'Stål'
    if (term === 'trae') return 'Træ'
    if (term === 'aluminium') return 'Aluminium'
    return term
  }
  return ''
}

export function getBoatBraendstof(boat) {
  if (!boat) return ''
  if (typeof boat.motor_braendstof === 'string' && boat.motor_braendstof.trim()) {
    return boat.motor_braendstof
  }
  const term = boat.terms?.braendstof?.[0]
  if (term) {
    if (term === 'diesel') return 'Diesel'
    if (term === 'benzin') return 'Benzin'
    if (term === 'el') return 'El'
    if (term === 'hybrid') return 'Hybrid'
    return term
  }
  return ''
}
